import React, { FC } from "react";

const style: React.CSSProperties = {
    height: "auto",
    verticalAlign: "middle",
    width: 20
};

const DialogflowIcon: FC<{ style?: React.CSSProperties }> = (props) => {
    return <img style={{...style, ...props.style}} src="/img/dialogflow-icon-only.svg" alt="Dialogflow Logo" />;
};

export { DialogflowIcon };
